<template>
    <div>
        <v-card-title class="pb-0" v-if="user.uid">
            Spielplan
            <v-spacer></v-spacer>
            <tool-tip text="Spiel anlegen">
                <v-btn v-if="user.permissions.ergebnisdienst" @click="editSpiel(null, null)"
                       fab color="primary" small>
                    <v-icon>mdi-plus</v-icon></v-btn>
            </tool-tip>
            <tool-tip text="spielfrei für Team anlegen">
                <v-btn v-if="user.permissions.ergebnisdienst && !isCup" @click="addSpielfrei(null)"
                       fab color="primary" small class="ml-3">
                    <v-icon>mdi-calendar-plus</v-icon></v-btn>
            </tool-tip>
        </v-card-title>
        <v-card-title class="pb-0 pt-2">
            <v-radio-group v-if="!isCup" v-model="semesterFilter" row class="d-inline-block"
                           :hide-details="$vuetify.breakpoint.smAndDown">
                <v-radio value="A">
                    <template v-slot:label><span class="body-2">ganzes Jahr</span></template>
                </v-radio>
                <v-radio value="H">
                    <template v-slot:label><span class="body-2">Herbst</span></template>
                </v-radio>
                <v-radio value="F">
                    <template v-slot:label><span class="body-2">Frühjahr</span></template>
                </v-radio>
            </v-radio-group>
            <v-radio-group v-model="spielStatus" row
                           :class="[{'mx-7': $vuetify.breakpoint.smAndUp && !isCup},
                                    {'mr-7': $vuetify.breakpoint.smAndUp && isCup}, 'd-inline-block']"
                           :hide-details="$vuetify.breakpoint.smAndDown">
                <v-radio value="played">
                    <template v-slot:label><span class="body-2">gespielt</span></template>
                </v-radio>
                <v-radio value="pending">
                    <template v-slot:label><span class="body-2">offen</span></template>
                </v-radio>
            </v-radio-group>
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                          label="Suchen" filled dense
                          :class="[{'mt-4': $vuetify.breakpoint.smAndDown}, 'mb-3 d-inline-block']"
                          single-line hide-details>
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
        </v-card-title>
        <div class="caption px-4">
            Klicke auf ein Team, den Status oder 'verspätet' um danach zu filtern, nochmaliges Klicken löscht den Filter.
        </div>
        <v-data-table :headers="headers" :items="spiele" :search="search" mobile-breakpoint="1"
                item-key="name" sort-by="details" :sort-desc="false" hide-default-footer
                group-by="rundeGroup" :group-desc="spielStatus==='played'" disable-pagination
                :class="[{'elevation-4 mx-2 ': $vuetify.breakpoint.mdAndUp}, 'mt-2 mb-3']"> <!--mobile-breakpoint="0"-->
            <template v-slot:group.header="{ group }" >
                <th :colspan="colspanText" style="position: relative"
                    :class="[{'text-center': $vuetify.breakpoint.mdAndUp},
                              'white--text grey darken-2 body-2 font-weight-medium']">
                          <span v-if="!isCup">Runde {{group.substr(6)}}</span>
                          <span v-else-if="group.indexOf('_') !== -1">{{group.split('_')[1]}}</span>
                          <span v-else>Runde {{group.substr(6).split(' ')[0]}}</span>
                </th>
                <th v-if="user.permissions.ergebnisdienst" colspan="1"
                    class="text-center white--text grey darken-2 body-2">
                    <div style="white-space: nowrap">
                        <tool-tip text="Spiel anlegen">
                            <v-btn icon dark @click="editSpiel(null, group)"><v-icon>mdi-plus</v-icon></v-btn>
                        </tool-tip>
                        <tool-tip text="spielfrei für Team anlegen">
                            <v-btn icon dark @click="addSpielfrei(group)" class="ml-2">
                                <v-icon>mdi-calendar-plus</v-icon></v-btn>
                        </tool-tip>
                    </div>
                </th>
            </template>
            <template v-slot:group.summary="{group}">
                <td v-if="hasSpielfrei(group)"
                    :colspan="colspanText + 1" class="text-center grey lighten-5">
                    <span class="font-weight-bold mr-3">Spielfrei: </span>
                    <span v-for="(team, i) in saison.getSpielfreieTeamsForRunde(group)" :key="i">
                        {{team.name}}
                        <v-btn icon v-if="user.permissions.ergebnisdienst">
                            <spiel-plan-frei-delete :item="team" :runde="group" :saison="saison">
                            </spiel-plan-frei-delete>
                        </v-btn>
                        <span v-if="i < saison.getSpielfreieTeamsForRunde(group).length - 1"
                            class="mx-2">/ </span>
                    </span>
                </td>
            </template>
            <template v-slot:item.fwResult="{ item }">
                <div v-if="isCup" class="text-no-wrap">{{item.fwResult}}</div>
            </template>
            <template v-slot:item.arResult="{ item }">
                <div v-if="isCup" class="text-no-wrap">{{item.arResult}}</div>
            </template>
            <template v-slot:item.kegelResult="{ item }">
                <div style="white-space: nowrap">
                    <schnitt-feld :value="item.kegelResult.split(' : ')[0]"
                                  :spieler="saison.anzahlSpieler">
                    </schnitt-feld> :
                    <schnitt-feld :value="item.kegelResult.split(' : ')[1]"
                                  :spieler="saison.anzahlSpieler">
                    </schnitt-feld>
                </div>
            </template>
            <template v-slot:item.heimTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="heim" @filtered="setFilter"
                                          :class="[{ 'primary--text': hover },
                                                   { 'font-weight-bold': isCup && item.heimCupLeader }]">
                    </tab-teams-with-icons>
                </v-hover>
            </template>
            <template v-slot:item.gastTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="gast" @filtered="setFilter"
                                          :class="[{ 'primary--text': hover },
                                                   { 'font-weight-bold': isCup && item.gastCupLeader }]">
                    </tab-teams-with-icons>
                </v-hover>
            </template>
            <template v-slot:item.details="{item}">
                <div style="white-space: nowrap" class="font-weight-medium grey--text text--darken-2">{{item.termin}}</div>
                <div style="white-space: nowrap" class="caption">{{item.infos.ort}}</div>
                <div style="white-space: nowrap" class="caption">{{item.infos.bahn}}</div>
            </template>
            <template v-slot:item.info="{item}">
                <div class="text-no-wrap">
                    <v-chip small dense v-if="item.info.indexOf(' - neu')!==-1" color="success">NEU</v-chip>
                    {{item.info.replace(' - neu', '')}}
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div style="white-space: nowrap">
                    <div v-if="(user.permissions.ergebnisdienst || isSportobmann)&&
                               spielStatus!=='played' &&
                               item.referee.name===''" class="d-inline-block">
                        <v-btn icon @click="editSpiel(item, null)"><v-icon>mdi-pencil</v-icon></v-btn>
                        <spiel-plan-delete v-if="user.permissions.ergebnisdienst"
                                           :item="item" :saison="saison">
                        </spiel-plan-delete>
                    </div>
                    <div v-if="item.heim.result.kegel > 0 || item.gast.result.kegel > 0 ||
                                item.infos.stream || item.vereine.gast.indexOf('adminVerified') !== -1">
                        <v-btn v-if="item.infos.stream"
                               @click="openStream(item.infos.stream)" icon class="d-inline-block">
                            <v-icon :color="item.vereine.heim.indexOf('pending') !== -1?'blue':''">
                                mdi-video-box</v-icon>
                        </v-btn>
                        <v-btn icon @click="openSpielbericht(item)">
                            <v-icon>mdi-file-document-outline</v-icon>
                        </v-btn>
                        <spiel-berichte-admin-menu
                                v-if="user.permissions.ergebnisdienst || isSportobmann"
                                @adminEditSpielbericht="adminEditSpielbericht"
                                @adminEditMaL="adminEditMaL"
                                :spiel="item" :saison="saison"></spiel-berichte-admin-menu>
                    </div>
                    <div v-else class="d-inline-block">
                        <spiel-berichte-admin-menu
                                v-if="user.permissions.ergebnisdienst || isSportobmann"
                                @adminEditSpielbericht="adminEditSpielbericht"
                                @adminEditMaL="adminEditMaL"
                                :spiel="item" :saison="saison"></spiel-berichte-admin-menu>
                    </div>
                </div>
            </template>
            <template v-slot:item.statusText="{ item }">
                <spiel-status-text :spiel="item" @filtered="setFilter" :allowHover="true"></spiel-status-text>
            </template>
            <template v-slot:no-data>
                <td class="text-left grey--text">
                    <span v-if="spielStatus!=='played'">Der Spielplan wurde noch nicht erstellt!</span>
                    <span v-else>Es wurden noch keine Spiele gespielt!</span>
                </td>
            </template>
        </v-data-table>
        <div v-if="spielStatus==='played'"
             :class="[{'borderTop pt-2 pl-3': $vuetify.breakpoint.smAndDown}]">
            <div :class="[{'d-inline-block ml-3': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="blue" small class="mr-1">mdi-star</v-icon>
                Mannschaftsrekord
            </div>
            <div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="blue" small class="mr-1">mdi-account-star</v-icon>
                Einzelrekord
            </div>
            <div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="error" small class="mr-1">mdi-alert</v-icon>
                Protest eingelegt
            </div>
            <div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="grey" small class="mr-1">mdi-information</v-icon>
                Bestätigungsfristen: Heim {{fristen.heim}}h, Gast {{fristen.gast}}h
            </div>
            <!--<div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="primary" small class="mr-1">mdi-alert</v-icon>
                Ergebnis abgelehnt
            </div>-->
        </div>
        <spiel-plan-edit v-if="$route.query.action==='editSpielPlan'" :default="defaultRunde" :is-cup="isCup"
                         :current-data="selectedSpiel" :saison="saison"></spiel-plan-edit>
        <spiel-bericht-edit-confirm v-if="$route.query.action==='displayErgebnis'" :set-realtime="true"
                                    :currentData="selectedSpiel" action="displayErgebnis">
        </spiel-bericht-edit-confirm>
        <spiel-bericht-edit-ergebnis v-if="$route.query.action==='editErgebnisAdmin'"
                                     :currentData="selectedSpiel" action="editErgebnisAdmin">
        </spiel-bericht-edit-ergebnis>
        <spiel-bericht-edit-ma-l v-if="$route.query.action==='editMaLAdmin'" action="editMaLAdmin"
                                 :currentData="selectedSpiel">
        </spiel-bericht-edit-ma-l>
        <spiel-plan-frei v-if="$route.query.action==='addSpielfrei'"
                         :defaultRunde="defaultRunde" :saison="saison">
        </spiel-plan-frei>
    </div>
</template>

<script>
    //import TimeStamp from "../../services/timeStamp";
    import SpielPlanEdit from "./spielPlanEdit";
    import SpielPlanDelete from "./spielPlanDelete";
    import SpielBerichtEditConfirm from "./spielbericht/edit/spielBerichtEditConfirm";
    //import {Spiel} from "../../services/data/spiel";
    import SchnittFeld from "./components/schnittFeld";
    import TabTeamsWithIcons from "./components/tabTeamsWithIcons";
    import ToolTip from "../../components/elements/toolTip";
    import SpielPlanFrei from "./spielPlanFrei";
    import SpielPlanFreiDelete from "./spielPlanFreiDelete";
    import { db } from '../../services/db'
    import SpielStatusText from "./components/spielStatusText";
    import SpielBerichteAdminMenu from "./spielbericht/spielBerichteAdminMenu";
    import SpielBerichtEditErgebnis from "./spielbericht/edit/spielBerichtEditErgebnis";
    import SpielBerichtEditMaL from "./spielbericht/edit/spielBerichtEditMaL";
    import SpielService from "@/services/data/spielService";

    export default {
        components: {
            SpielBerichtEditMaL,
            SpielBerichtEditErgebnis,
            SpielBerichteAdminMenu,
            SpielStatusText,
            SpielPlanFreiDelete,
            SpielPlanFrei,
            ToolTip,
            TabTeamsWithIcons,
            SchnittFeld,
            SpielBerichtEditConfirm,
            SpielPlanDelete,
            SpielPlanEdit},
        name: "spiel-plan",
        props: ['saison', 'isCup'],
        computed: {
            user(){ return this.$store.state.user; },
            fristen(){
                return SpielService.getFristen(this.saison? this.saison.id : '');
            },
            isSportobmann(){
                const sportObmannRole = 'sportobmann_' + this.saison.lvId;
                return this.user.permissions[sportObmannRole] === true
            },
            spiele(){ return this.saison ?
                this.saison.getSpielPlanList(this.semesterFilter, this.spielStatus) : []; },
            colspanText() {
                return this.spielStatus === 'played' ?
                    this.user.permissions.ergebnisdienst ? 9:10 :
                    this.user.permissions.ergebnisdienst ? 5:6;
            },
            actionHeader(){ return !this.user.uid?'Spielbericht':'Aktionen'; }
        },
        data: () => ({
            search: null,
            headers: [],
            selectedSpiel: null,
            defaultRunde: null,
            semesterFilter: 'A',
            spielStatus: 'played'
        }),
        created(){
            this.setTableHeader();
            //this.setSemesterFilterDependendOnDate();
            //this.loadSpielIfSetInRoute();
        },
        methods: {
            setFilter(value){
                if ( this.search === value  ) {
                    this.search = ''
                } else {
                    this.search = value
                }
            },
            hasSpielfrei(group){
                if ( this.saison && this.saison.spielfrei) {
                    const groupTemp = JSON.parse(JSON.stringify(group)).split('_')
                    let runde = groupTemp[0].substr(6).replace(' ', '_');
                    if ( this.saison.spielfrei[runde] && Object.keys(this.saison.spielfrei[runde]).length ) {
                        return true;
                    }
                }
                return false;
            },
            async openSpielbericht(spiel){
                /*let fullSpiel = await this.getFullSpiel(spiel);
                this.selectedSpiel = new Spiel();
                this.selectedSpiel.setFromDataObject(fullSpiel);*/
                //this.selectedSpiel = spiel;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'displayErgebnis';
                q.spielId = spiel.id;
                this.$router.push({path: p, query: q});
            },
            /*setSemesterFilterDependendOnDate(){
                const today = TimeStamp.getTodayString();
                this.semesterFilter = parseInt(today.substr(5, 2)) < 6 ? 'F' : 'A';
            },*/
            setTableHeader(){
                this.headers = this.spielStatus === 'played' ?
                    this.isCup ?
                    [   { text: '', value: 'rundeGroup'},
                        { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                        { text: '', value: 'vs', align: 'center', sortable: false},
                        { text: 'Gastteam', value: 'gastTeam', sortable: false},
                        { text: 'FW', value: 'fwResult', sortable: false},
                        { text: 'Abr.', value: 'arResult', sortable: false},
                        { text: 'Kegel', value: 'kegelResult', sortable: false},
                        { text: 'Status', value: 'statusText', sortable: false},
                    ] : [   { text: '', value: 'rundeGroup'},
                        { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                        { text: '', value: 'vs', align: 'center', sortable: false},
                        { text: 'Gastteam', value: 'gastTeam', sortable: false},
                        { text: 'Pkt', value: 'tabPktResult', sortable: false},
                        { text: 'MaP', value: 'mpResult', sortable: false},
                        { text: 'SaP', value: 'spResult', sortable: false},
                        { text: 'Kegel', value: 'kegelResult', sortable: false},
                        { text: 'Status', value: 'statusText', sortable: false},
                    ] : [
                        { text: '', value: 'rundeGroup'},
                        { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: true},
                        { text: '', value: 'vs', align: 'center', sortable: false},
                        { text: 'Gastteam', value: 'gastTeam', sortable: true},
                        { text: 'Details', value: 'details'},
                        { text: 'Status', value: 'statusText', sortable: false},
                    ];
                if ( this.spielStatus === 'played' ||
                     this.user.permissions.ergebnisdienst ||
                     this.isSportobmann
                ) {
                    this.headers.push({ text: this.actionHeader, value: 'actions', sortable: false, align: 'center' });
                }
                if ( this.spielStatus === 'played' ){
                    this.headers.push({ text: 'Gespielt am', value: 'info' });
                }
            },
            async editSpiel(spiel, defaultRunde){
                let fullSpiel = spiel ? await this.getFullSpiel(spiel) : spiel;
                if(!fullSpiel){ this.setDefaultRunde(defaultRunde) }
                this.selectedSpiel = fullSpiel;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editSpielPlan';
                this.$router.push({path: p, query: q});
            },
                setDefaultRunde(defaultRunde){
                    if ( defaultRunde ) {
                        let spiel = this.spiele.filter(spiel => spiel.rundeGroup === defaultRunde )[0];
                        this.defaultRunde = { semester: spiel.saison.semester, runde: spiel.saison.runde }
                    } else {
                        this.defaultRunde = { semester: this.semesterFilter, runde: null };
                    }
                },
            addSpielfrei(defaultRunde){
                this.defaultRunde = defaultRunde ? defaultRunde : null;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'addSpielfrei';
                this.$router.push({path: p, query: q});
            },
            getFullSpiel(spiel){
                return new Promise( (resolve) => {
                    db.collection('spiele').doc(spiel.id).get()
                        .then((doc) => {
                            console.log("Document successfully deleted!");
                            let spielTemp = doc.data();
                            spielTemp.id = doc.id;
                            resolve(spielTemp)
                        })
                        .catch((error) => {
                            console.error("Error deleting document: ", error);
                            resolve(spiel)
                        });
                })
            },
            openStream(url){
                window.open(url, '_blank').focus();
            },
            /*async loadSpielIfSetInRoute(){
                if ( this.$route.query.spielId ) {
                    let fullSpiel = await this.getFullSpiel({id: this.$route.query.spielId, emptySpiel: true });
                    if ( fullSpiel.emptySpiel ) {
                        let p = JSON.parse(JSON.stringify(this.$route.path));
                        let q = JSON.parse(JSON.stringify(this.$route.query));
                        delete q.action;
                        delete q.spielId;
                        this.$router.replace({path: p, query: q});
                    }
                    this.selectedSpiel = new Spiel();
                    this.selectedSpiel.setFromDataObject(fullSpiel);
                }
            }*/
            async adminEditSpielbericht(spiel){
                this.selectedSpiel = await this.getFullSpiel(spiel);
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editErgebnisAdmin';
                this.$router.push({path: p, query: q});
            },
            async adminEditMaL(spiel){
                this.selectedSpiel = await this.getFullSpiel(spiel);
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editMaLAdmin';
                this.$router.push({path: p, query: q});
            }
        },
        watch: {
            spielStatus(){
                this.setTableHeader();
            }
        }
    }
</script>

<style scoped>
    .borderTop {border-top: solid 1px lightgrey}
    .plusBtnMobile {position: absolute; right: 10px; bottom: 5px}
</style>